export default __webpack_public_path__ + "static/media/fixed-skylight.2f56e45e.jpg";